import { CalendahProvider } from '@/modules/calendah/types/calendah-provider';
import { CALENDAH_PROVIDERS } from '@/modules/calendah/constants/calendah-provider';
import HubSpot from '@/modules/calendah/assets/providers/hubspot.svg';
import Google from '@/modules/calendah/assets/providers/google.svg';
import Microsoft from '@/modules/calendah/assets/providers/microsoft.svg';
import Apple from '@/modules/calendah/assets/providers/apple.svg';

export const PROVIDER_LABEL = new Map<CalendahProvider, string>([
    [
        CALENDAH_PROVIDERS.HUB_SPOT,
        'HubSpot',
    ],
    [
        CALENDAH_PROVIDERS.GOOGLE,
        'Google',
    ],
    [
        CALENDAH_PROVIDERS.OUTLOOK,
        'Outlook',
    ],
    [
        CALENDAH_PROVIDERS.APPLE,
        'Apple',
    ],
]);

export const PROVIDER_ICONS = new Map<CalendahProvider, string>([
    [
        CALENDAH_PROVIDERS.HUB_SPOT,
        HubSpot,
    ],
    [
        CALENDAH_PROVIDERS.GOOGLE,
        Google,
    ],
    [
        CALENDAH_PROVIDERS.OUTLOOK,
        Microsoft,
    ],
    [
        CALENDAH_PROVIDERS.APPLE,
        Apple,
    ],
]);

export const PROVIDER_LINKS = new Map<CalendahProvider, string>([
    [
        CALENDAH_PROVIDERS.GOOGLE,
        'https://support.google.com/calendar/answer/37648?hl=en#zippy=%2Csecret-address',
    ],
    [
        CALENDAH_PROVIDERS.OUTLOOK,
        'https://support.microsoft.com/en-au/office/share-your-calendar-in-outlook-on-the-web-7ecef8ae-139c-40d9-bae2-a23977ee58d5',
    ],
]);

export const PROVIDER_FILTERS = new Map<CalendahProvider, boolean>([
    [
        CALENDAH_PROVIDERS.HUB_SPOT,
        true,
    ],
    [
        CALENDAH_PROVIDERS.GOOGLE,
        false,
    ],
    [
        CALENDAH_PROVIDERS.OUTLOOK,
        false,
    ],
    [
        CALENDAH_PROVIDERS.APPLE,
        false,
    ],
]);
